import angular from 'angular';
import 'ng-file-upload/dist/ng-file-upload';
import 'satellizer';
import ResourcesModule from '../../resources/resources';
import ServicesModule from '../../services/services';
import ConfigsModule from '../../configs/configs';
import template from './campaignsEdit.jade';
import { normalizeAutoGoalsOptimizationFields } from '../../common/util/validation-util';

export class CampaignsEditController {
  /* @ngInject */
  constructor($stateParams, $filter, $state, $scope, $timeout, CampaignsV4Resource, SegmentsResource, GamesResource, campaignTargetingsConstants, currentUser, currentGame, platformsOptions, notify, Upload, $auth, $q) {
    this.$q = $q;
    this.$scope = $scope;
    this.translate = $filter('translate');
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.$timeout = $timeout;
    this.platformsOptions = platformsOptions;
    this.CampaignsV4Resource = CampaignsV4Resource;
    this.SegmentsResource = SegmentsResource;
    this.GamesResource = GamesResource;
    this.currentGame = currentGame;
    this.notify = notify;
    this.Upload = Upload;
    this.$auth = $auth;
    this.campaignTargetingsConstants = campaignTargetingsConstants;
    this.campaign = this.resource = {type: $stateParams.type};
    currentUser.subscribe((user) => {
      this.user = user;
    });
    this.gameVariations = [];
    this.activeCampaignTab = 'campaign';
    this.isResourceBeingPersisted = false;
    this.isAdvancedOptionsOpen = false;
    this.disabledOptions = {
      start_mode_immediate: false,
      start_mode_dont_start: false
    };
    this.disposables = [];

    this.availableColors = ['Red','Green','Blue','Yellow','Magenta','Maroon','Umbra','Turquoise'];

    this.colors = ['Blue','Red'];

    this.disposables.push(this.currentGame.subscribe(game => this.game = game));

    if (this.campaign.type === 'BrandingCPM') {
      this.campaign.campaign_success_metric = 'game_event_new_player';
    }

    if ($stateParams.activeTab) {
      this.activeCampaignTab = $stateParams.activeTab;
    }

    if ($stateParams.id) {
      this.getCampaign($stateParams.id)
    } else {
      const dayPartsDefaultValues = _.map(_.range(1,8), day => {
          const hours = _.reduce(_.range(24), (result, key) => {
            result[key] = true;
            return result
          }, {});

          return {...hours, day: day};
        }
      )
      this.campaign.autopilot_launcher_state = 'inactive';
      this.campaign.auto_goals_optimization = false;
      this.campaign.auto_goals_optimization_interval_days = 3;
      this.campaign.goals_optimization_method = 'roi';
      this.campaign.impression_attribution_percentage = 100;
      this.campaign.platforms = ['Global'];
      this.campaign.targetings = {cities:[], regions:[], deviceOsVersion:[], dayParts: _.sortBy(dayPartsDefaultValues, dp => dp.day), sspChannels:[], deviceIdType: "IDFA"};
      this.campaign.targeting_groups = {
        bundleIds: false,
        cities: false,
        countries: false,
        deviceModels: false,
        deviceOsVersion: false,
        regions: false,
        sspChannels: false,
        ssps: false
      };
      this.campaign.frequency_caps = this.campaignTargetingsConstants.transformFrequencyCaps({id: null});
      //TODO REMOVE THIS WHEN THE FIELD WILL BE HANDLED BY THE BACKEND
      this.campaign.second_auction_bid = '+10%';

      if ($stateParams.campaign) {
        this.campaign = $stateParams.campaign;
      }

      this.markAssociatedVariations();

      if(this.$stateParams.audience) {
        this.campaign.audience_id = this.$stateParams.audience.id;
      }
      this.campaign.ssp_fees = [];
      this.new = true;
      this.getCampaignCurrency();
    }

    this.campaign.game_id = this.$stateParams.gameId;
    this.getSegments();

    this.$scope.$watch('vm.campaign.platforms', (newVal, oldVal) => {
      this.handlePlatformsChanges(newVal, oldVal);
    });

    this.disposeObservable = (d) => { d.dispose() };
    this.$onDestroy = () => { _.forEach(this.disposables, (d) => this.disposeObservable(d)) };

  }

  handlePlatformsChanges(newVal, oldVal) {
    if(_.isEqual(newVal, ['Global']) || !_.includes(newVal, 'Global')) {
      this.campaign.platforms = newVal;
    } else if(_.includes(newVal, 'Global') && !_.includes(oldVal, 'Global')) {
      this.campaign.platforms = ['Global'];
    } else if(!_.includes(_.difference(newVal, oldVal), 'Global')) {
      this.campaign.platforms = _.pull(newVal, 'Global');
    }
  }

  goTo(campaignTab) {
    this.activeCampaignTab = campaignTab;
  }

  cloneCampaign() {
    this.$state.go('app.campaigns.clone', {
      campaign: _.omit(this.campaign.plain(), 'currency')
    });
  }

  getTrackingLinksMatchingInfo(campaign, gamePlatforms) {
    if(!gamePlatforms.length) {return true;}

    let areAllPlatformLinksTheSame = true;
    let referenceUrl = campaign.urls[gamePlatforms[0]];
    let referenceImpressionPostbackUrl = campaign['impression_postback_ios'] || campaign['impression_postback_android'];
    let referenceClickPostbackUrl = campaign['click_postback_ios'] || campaign['click_postback_android'];
    let referenceImpressionEngagementPostbackUrl = campaign['impression_engagement_postback_ios'] || campaign['impression_engagement_postback_android'];
    let referenceClickEngagementPostbackUrl = campaign['click_engagement_postback_ios'] || campaign['click_engagement_postback_android'];
    let referenceClickDeeplinkUrl = campaign['default_deep_link_ios'] || campaign['default_deep_link_android'];
    let referenceClickAfterCompleteUrl = campaign['video_complete_postback_ios'] || campaign['video_complete_postback_android'];
    _.forEach(gamePlatforms, (gamePlatform) => {
      if(campaign.urls[gamePlatform] !== referenceUrl) {
        areAllPlatformLinksTheSame = false;
      }
      if((gamePlatform === 'Android' || gamePlatform === 'iOS' )&& referenceImpressionPostbackUrl !== campaign['impression_postback_'+gamePlatform.toLowerCase()]) {
        areAllPlatformLinksTheSame = false;
      }
      if((gamePlatform === 'Android' || gamePlatform === 'iOS' )&& referenceClickPostbackUrl !== campaign['click_postback_'+gamePlatform.toLowerCase()]) {
        areAllPlatformLinksTheSame = false;
      }
      if((gamePlatform === 'Android' || gamePlatform === 'iOS' )&& referenceImpressionEngagementPostbackUrl !== campaign['impression_engagement_postback_'+gamePlatform.toLowerCase()]) {
        areAllPlatformLinksTheSame = false;
      }
      if((gamePlatform === 'Android' || gamePlatform === 'iOS' )&& referenceClickEngagementPostbackUrl !== campaign['click_engagement_postback_'+gamePlatform.toLowerCase()]) {
        areAllPlatformLinksTheSame = false;
      }
      if((gamePlatform === 'Android' || gamePlatform === 'iOS' )&& referenceClickDeeplinkUrl !== campaign['default_deep_link_'+gamePlatform.toLowerCase()]) {
        areAllPlatformLinksTheSame = false;
      }
      if((gamePlatform === 'Android' || gamePlatform === 'iOS' )&& referenceClickAfterCompleteUrl !== campaign['video_complete_postback_'+gamePlatform.toLowerCase()]) {
        areAllPlatformLinksTheSame = false;
      }
    });
    return {result: areAllPlatformLinksTheSame, referenceUrl, referenceImpressionPostbackUrl, referenceClickPostbackUrl, referenceImpressionEngagementPostbackUrl,referenceClickEngagementPostbackUrl, referenceClickDeeplinkUrl, referenceClickAfterCompleteUrl};
  }

  getCampaignPlatformsForUI(campaign) {
    let allPlatforms = _.map(this.platformsOptions,'value');
    let linksMatchingResultObject = this.getTrackingLinksMatchingInfo(campaign, allPlatforms);
    if(linksMatchingResultObject.result) {
      this.campaign.platforms = ['Global'];
      this.campaign.url_global = linksMatchingResultObject.referenceUrl;
      this.campaign.global_postback = linksMatchingResultObject.referenceImpressionPostbackUrl;
      this.campaign.global_click_postback = linksMatchingResultObject.referenceClickPostbackUrl;
      this.campaign.global_impression_engagement_postback = linksMatchingResultObject.referenceImpressionEngagementPostbackUrl;
      this.campaign.global_click_engagement_postback = linksMatchingResultObject.referenceClickEngagementPostbackUrl;
      this.campaign.global_click_deeplink = linksMatchingResultObject.referenceClickDeeplinkUrl;
      this.campaign.global_click_after_complete_postback = linksMatchingResultObject.referenceClickAfterCompleteUrl;
    } else {
      this.campaign.platforms = _(campaign.urls).omitBy(_.isUndefined).omitBy(_.isNull).keys().value();
    }
  }

  markAssociatedVariations(){
    this.GamesResource.one(this.$stateParams.gameId).getList('variations', {variation_status: true})
    .then((gameVariations) => {
      this.gameVariations = _.filter(gameVariations, gameVariation => {
        const isTimeframeActive =
            (!!gameVariation.start_date && moment(gameVariation.start_date).isBefore(moment(),'minutes'))
            && (gameVariation.end_date === null || moment(gameVariation.end_date).isAfter(moment(),'minutes'));
        return isTimeframeActive;
      });
      this.gameVariations.forEach((gameVariation) => {
        gameVariation.selected = !!_.find(this.campaign.variation_ids, cmpVariationId => cmpVariationId === gameVariation.id);
      })
    });
  }

  getCampaign(id) {
    return this.CampaignsV4Resource.one(id).get().then((res) => {
      this.campaign = this.resource = res;
      this.campaign.platform = this.getCampaignPlatformsForUI(this.campaign);

      //TODO REMOVE THIS WHEN THE FIELD WILL BE HANDLED BY THE BACKEND
      this.campaign.second_auction_bid = '+10%';

      this.getCampaignCurrency();
      this.campaign.game_id = this.$stateParams.gameId;
      this.disabledOptions.start_mode_immediate = this.campaign.status === 'active';
      this.disabledOptions.start_mode_dont_start = this.campaign.status === 'active';
      this.markAssociatedVariations();
      normalizeAutoGoalsOptimizationFields(this.campaign);
    });
  }

  getSegments() {
    return this.SegmentsResource.getList({game_id: this.$stateParams.gameId})
        .then(segments => this.segments = segments.plain());
  }

  getCampaignCurrency(){
    this.campaign.currency = 'USD';
  }

  delete() {
    this.notify.warning('At the moment campaigns cannot be deleted');
  }

  preSerializeTargetingLinks() {
    if(_.isEqual(this.campaign.platforms, ['Global'])) {
      let gamePlatforms = _.map(this.platformsOptions,'value');
      _.forEach(gamePlatforms, (gamePlatform) => {
        this.campaign['url_'+gamePlatform] = this.campaign.url_global;
        if((gamePlatform === 'Android' || gamePlatform === 'iOS' )) {
          this.campaign['impression_postback_'+gamePlatform.toLowerCase()] = this.campaign.global_postback;
          this.campaign['click_postback_'+gamePlatform.toLowerCase()] = this.campaign.global_click_postback;
          this.campaign['impression_engagement_postback_'+gamePlatform.toLowerCase()] = this.campaign.global_impression_engagement_postback;
          this.campaign['click_engagement_postback_'+gamePlatform.toLowerCase()] = this.campaign.global_click_engagement_postback;
          this.campaign['default_deep_link_'+gamePlatform.toLowerCase()] = this.campaign.global_click_deeplink;
          this.campaign['video_complete_postback_'+gamePlatform.toLowerCase()] = this.campaign.global_click_after_complete_postback;
        }
      });
    } else {
      let notSelectedPlatforms = _.difference(_.map(this.platformsOptions,'value'), this.campaign.platforms);
      _.forEach(notSelectedPlatforms, (notSelectedPlatform) => {
        this.campaign['url_'+notSelectedPlatform] = null;
        if((notSelectedPlatform === 'Android' || notSelectedPlatform === 'iOS' )) {
          this.campaign['impression_postback_'+notSelectedPlatform.toLowerCase()] = null;
          this.campaign['click_postback_'+notSelectedPlatform.toLowerCase()] = null;
          this.campaign['impression_engagement_postback_'+notSelectedPlatform.toLowerCase()] = null;
          this.campaign['click_engagement_postback_'+notSelectedPlatform.toLowerCase()] = null;
          this.campaign['default_deep_link_'+notSelectedPlatform.toLowerCase()] = null;
          this.campaign['video_complete_postback_'+notSelectedPlatform.toLowerCase()] = null;
        }
      });
    }
  }

  save() {
    let nonActiveSelectedVariationIds = _.filter(this.campaign.variation_ids, existingVar => !_.find(this.gameVariations, gameVariation => existingVar === gameVariation.id));
    let activeSelectedVariationsIds = _.filter(this.gameVariations, variation => variation.selected).map(variation => variation.id);
    this.campaign.variation_ids = [...nonActiveSelectedVariationIds, ...activeSelectedVariationsIds];
    normalizeAutoGoalsOptimizationFields(this.campaign);
    this.preSerializeTargetingLinks();
    this.isResourceBeingPersisted = true;
    if (this.resource.id) {
      this.update();
    } else {
      this.create();
    }
  }

  create() {
    this.CampaignsV4Resource.post(this.campaign)
      .then((res) => {
          this.getCampaignCurrency();
          this.notify.created('campaign', this.campaign.name);
          this.$state.go('app.campaigns.edit', {id: res.id});
      })
      .catch((res) => {
          this.notify.apiError(res);
          this.isResourceBeingPersisted = false;
      })
      .finally(() => { this.isResourceBeingPersisted = false; });
  }

  update() {
    this.resource.save()
      .then((res) => {
          this.getCampaignCurrency();
          this.notify.updated('campaign', this.campaign.name);
          // Calling mirror just to use the "reload current state" functionality of it, since $state.reload() doesn't seem to
          // recall the controller, https://github.com/angular-ui/ui-router/issues/582
          // $state.reload() seems to call the "resolves" but not the controller function itself
          this.$state.go('mirror', { extraParam: 'activeTab--' + this.activeCampaignTab });
        })
      .catch((res) => {
        this.notify.apiError(res);
        this.isResourceBeingPersisted = false;
      })
      .finally(() => { this.isResourceBeingPersisted = false; });

  }

  hasDemoRole() {
    return this.user && this.user.id && this.user.hasRole && this.user.hasRole(['DEMO']);
  }

  belongToYouappiGames() {
    return this.currentGame.value.id === 1526 || this.currentGame.value.id === 1823;
  }
}

let CampaignsEditComponentOptions = {
  template: ($element, $attrs) => { return template; },
  controller: CampaignsEditController,
  controllerAs: 'vm',
  bindings: {}
};

export default angular.module('app.components.campaigns.edit', [
  'ngFileUpload',
  'satellizer',
  ResourcesModule.name,
  ServicesModule.name,
  ConfigsModule.name,
])
  .component('campaignsEdit', CampaignsEditComponentOptions);



/** WEBPACK FOOTER **
 ** ./src/components/campaigns/campaignsEdit.js
 **/